import styled from '@emotion/styled';

export const SFormContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 28px;
  row-gap: 4px;

  .custom-ant-form-item {
    width: calc(50% - 14px);
  }
`;

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
